import { Card, CardContent } from '@mui/material';

import { useHeaderWidth } from '../../shared/hooks/useHeaderWidth';

import { TransactionHistoryTable } from './transaction-history-table';

export default function TransactionHistory() {
  const headerWidth = useHeaderWidth();

  return (
    <Card
      sx={[
        () => ({
          display: 'flex',
          zIndex: 'unset',
          overflow: 'unset',
          mt: 5,
          borderRadius: 2,
          boxShadow: 'var(--customShadows-card)',
          width: headerWidth,
        }),
      ]}
    >
      <CardContent sx={{ flexGrow: 1, padding: '2 rem' }}>
        <TransactionHistoryTable />
      </CardContent>
    </Card>
  );
}
